export default {
  background: '#707785',
  borderColor: '#707785',
  hoverColor: '#4287f5',
  line: '#1A1A1A',
};
